module.exports = __webpack_public_path__ + "img/logo-axesa.d88296e7.svg";